PegasusTemplate.TemplateController = Ember.ObjectController.extend({
  needs: [
    'toolbar',
    'editing',
    'blockOperations',
    'socialFollow',
    'rowOperations',
    'mainTabPanel',
    'themes',
    'autoSave',
    'viewOptions'
  ],

  isEditingCapturePalette: false,

  intrinsicTemplateWidth: function(){
    return PegasusTemplate.get('blockRegionInstance.intrinsicWidth');
  }.property('PegasusTemplate.blockRegionInstance.intrinsicWidth'),

  draggingMuted: function(_,value){
    if ( typeof(value) !== 'undefined' ) {
      return value;
    }

    return false;
  }.property(),
  isSaving: false,
  isStandalone: function(){
    return window === window.parent;
  }.property(),
  next: function(){
    this.set('isSaving', true);
    this.send('saveAndContinue');
  },
  exit: function(){
    this.set('isSaving', true);
    this.send('saveAndExit');
  },
  lastSaved: function(){
    return this.get('controllers.autoSave.lastSaved');
  }.property('controllers.autoSave.lastSaved'),
  forwardInstruction: function(){
    return Em.get(PegasusTemplate, 'options.forwardInstruction');
  }.property('PegasusTemplate.options'),
  applyFontFace: function(){
    this.get('controllers.toolbar').didChangeSelectedFontFace();
  },
  focusedRow: function(){
    return this.get('controllers.rowOperations.content');
  }.property('controllers.rowOperations.content'),
  shouldShowViewOnline: true,
  hasHidden: function(){
    return !!( $('.user-hidden').length );
  }.property(),
  hasHiddenDidChange: function(){
    this.send('broadcastHiddenState', this.get('hasHidden'));
  }.observes('hasHidden'),
  revealHidden: function(_,value){
    $('.user-hidden-styles').remove();
    var styleString = $('<style class="user-hidden-styles" type="text/css">html .user-hidden {opacity: 0.3;height: auto;width:auto;visibility:visible;}</style>');

    if (typeof(value)!=='undefined') {
      if ( value ) {
        $('head').append( styleString );
      }
      return value;
    }
    return '';
  }.property(),
  toggleRevealHidden: function(){
    this.set('controllers.blockOperations.content', null);
    this.set('controllers.rowOperations.content', null);
    this.toggleProperty('revealHidden');
  },
  locateTemplateColors: function(){
    var colors = findCanvasColors().uniq();
    this.set('controllers.toolbar.userSelectedColors', colors);
  },
  currentZoomValue: function(){
    return this.get('controllers.viewOptions.zoomValue');
  }.property('controllers.viewOptions.zoomValue'),

  zoomClass: function(){
    return 'percent-' + this.get('currentZoomValue');
  }.property('currentZoomValue'),

  previewImageFor: function(name){
    return this.store.all(PegasusTemplate.Block).filterProperty('name', name).get('firstObject.preview_url_basic');
  }
});
